import { render, staticRenderFns } from "./HeroCarousel.vue?vue&type=template&id=3ad3f4a8&scoped=true"
import script from "./HeroCarousel.vue?vue&type=script&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&lang=js"
import style0 from "./HeroCarousel.vue?vue&type=style&index=0&id=3ad3f4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad3f4a8",
  null
  
)

export default component.exports